// extracted by mini-css-extract-plugin
module.exports = {"boxComment":"styles_boxComment__1ek7x"};